const BASE_URL = "https://cassiegee.com";

const DEFAULT_META = {
  title: "Cassie Gee Investments CC — Hardware, Building Materials, Mining & Export Supply | Est. 2003",
  description:
    "Cassie Gee Investments CC — established 2003. Trusted B2B supply partner for hardware, building materials, mining equipment, heavy machinery and commodities. Established export clients in Malawi, Tanzania and across the continent.",
};

export const PAGE_META = {
  "/": DEFAULT_META,
  "/about": {
    title: "About Us — 23 Years of Trusted B2B Supply | Cassie Gee Investments CC",
    description:
      "Founded in 2003, Cassie Gee Investments CC has spent over two decades supplying contractors, retailers and importers with hardware, building materials and heavy equipment. Learn our story.",
  },
  "/what-we-supply": {
    title: "What We Supply — Hardware, Building Materials, Mining Equipment & Commodities | Cassie Gee Investments",
    description:
      "Full-range B2B supply: hardware and tools, building materials, mining and heavy equipment, commodities and bulk goods. Sourced, quality-checked and delivered to contractors, retailers and importers.",
  },
  "/for-contractors": {
    title: "For Contractors — Reliable Site Supply & Bulk Pricing | Cassie Gee Investments",
    description:
      "Dedicated supply partner for contractors: bulk pricing, reliable delivery schedules, project-based procurement and account terms that keep your build moving. Request a contractor quote today.",
  },
  "/export-import": {
    title: "Export & Import — Cross-Border Supply to Malawi, Tanzania & Beyond | Cassie Gee Investments",
    description:
      "Established export operations with clients in Malawi, Tanzania and across the continent. Documentation, logistics and consolidated shipments handled end-to-end for African importers.",
  },
  "/renovation-construction": {
    title: "Renovation & Construction Services | Cassie Gee Investments CC",
    description:
      "Renovation and construction capability backed by 23 years of materials expertise — refurbishments, structural work and turnkey project supply for commercial and industrial clients.",
  },
  "/clients": {
    title: "Our Clients — Contractors, Retailers & Importers We Serve | Cassie Gee Investments",
    description:
      "Trusted by contractors, hardware retailers and cross-border importers for over two decades. See the sectors we serve and why clients keep coming back.",
  },
  "/contact": {
    title: "Contact Us — Request a Quote | Cassie Gee Investments CC, Pretoria",
    description:
      "Get in touch for quotes, bulk supply or export enquiries. Call +27 79 540 2898 or send an enquiry — our team responds within one business day.",
  },
};

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export const applyPageMeta = (pathname) => {
  const path = pathname.replace(/\/+$/, "") || "/";
  const meta = PAGE_META[path] || DEFAULT_META;
  const url = path === "/" ? `${BASE_URL}/` : `${BASE_URL}${path}`;

  document.title = meta.title;
  setMeta('meta[name="description"]', "content", meta.description);
  setMeta('link[rel="canonical"]', "href", url);
  setMeta('meta[property="og:url"]', "content", url);
  setMeta('meta[property="og:title"]', "content", meta.title);
  setMeta('meta[property="og:description"]', "content", meta.description);
  setMeta('meta[name="twitter:title"]', "content", meta.title);
  setMeta('meta[name="twitter:description"]', "content", meta.description);

  const robots = document.head.querySelector('meta[name="robots"]');
  if (robots) {
    const isKnown = Boolean(PAGE_META[path]);
    robots.setAttribute(
      "content",
      isKnown ? "index, follow, max-image-preview:large, max-snippet:-1" : "noindex, follow"
    );
  }
};
